<div id="{{config.name}}" class="dynamic-field form-array" [formGroup]="group.controls[config.name]"
	ix-auto ix-auto-type="array" ix-auto-identifier="{{config.placeholder}}">
    <fieldset class="formarray-fieldset" *ngFor="let array of group.controls[config.name]['controls']; let i = index ">
      <ng-container *ngFor="let field of config.formarray" dynamicField [config]="field" [group]="group.controls[config.name].controls[i]">
      </ng-container>
    </fieldset>
  <form-errors [control]="group.controls[config.name]" [config]="config"></form-errors>
  <mat-error *ngIf="config['hasErrors']">{{config['errors']}}</mat-error>
</div>
